import React, { useEffect, useRef, useState } from "react";
import { Form, Button } from "semantic-ui-react";
import { useForm } from "react-hook-form";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  member_edit,
  member_update,
  get_amount_by_term_id,
} from "../../../../apis/studentManagement/StudentManagement";
import {
  branch_all,
  course_type_all,
  state_branch_all,
} from "../../../../apis/Branches";
import { grade_all } from "../../../../apis/Grade";
import {
  get_days,
  get_terms_by_state_user_id,
} from "../../../../apis/Common";
import DataLoader from "../../../../Utils/DataLoader";
import { handleNavigation } from "../../../../Utils/Utils.js";
import StripePaymentModal from "./StripePayment.jsx";
import UpdateStudentCourse from "./UpdateStudentCourse.jsx";
const EditMember = () => {
  const [gradelist, setGradeList] = useState([]);
  const [branchlist, setBranchList] = useState([]);
  const [coursetypeList, setCoursetypeList] = useState([]);
  const [days, setDays] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [termData, setTermData] = useState([]);
  const [gradeID, setGradeId] = useState("");
  const [stateID, setStateId] = useState("");
  const [disabledStudentType, setDisabledStudentType] = useState(false);
  const [disabledUpdateCourse,setDisabledUpdateCourse]=useState(false);
  const [show, setShow] = useState(false);
  const [type,setType]=useState('');
  const localData = localStorage.getItem("userData");
  const BranchData = JSON.parse(localData);
  const [openUpdateCourseModal, setOpenUpdateCourseModal] = useState(false)
  const {
    register,
    handleSubmit,
    control,
    setValue,
    getValues,
    formState: { errors, isDirty },
    watch,
  } = useForm({ mode: "onChange" });
  const user_id = localStorage.getItem("user_id");
  const navigate = useNavigate();
  const password = useRef({});
  const classroom_gmail = useRef({});
  const p_email = useRef({});
  const id = useParams();
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [amount, setAmount] = useState("");
  const [paymentIntentId, setPaymentIntentID] = useState("");
  const [isOpenPaymentModal, setIsOpenPaymentModal] = useState(false);
  const [previousData, setPreviousData] = useState({
    termID: "",
    studentType: "",
  });
  const [userData, setUserData] = useState({
    user_id: "",
    term_id: "",
  });
  const term_id = watch("term_id");
  const grade_id=watch("grade");
  useEffect(() => {
    const today = new Date();
    const maxDateCalc = new Date(
      today.getFullYear() - 0,
      today.getMonth(),
      today.getDate()
    );
    const minDateCalc = new Date(today.getFullYear() - 20, 0, 2);
    setMaxDate(maxDateCalc.toISOString().split("T")[0]);
    setMinDate(minDateCalc.toISOString().split("T")[0]);
    const fetchAmount = async () => {
      const data = await get_amount_by_term_id(term_id);
      setAmount(data?.data);
    };
    if (term_id) {
      fetchAmount();
    }
  }, [term_id]);
  password.current = watch("password", "");
  classroom_gmail.current = watch("classroom_gmail", "");
  p_email.current = watch("p_email", "");
  const onSubmit = async (data) => {
    data.state = BranchData?.data?.branchstate;
    data.amount = amount ? amount : "";
    data.payment_id = paymentIntentId ? paymentIntentId : "";
    if (!data.password) {
      delete data.password;
      delete data.confirmPassword;
    }
    if (isSubmitting) return;
    setIsSubmitting(true);
    data.pc_email = "";
    console.log("Submitting data:", data);

    let result = await member_update(id, data);
    if (result.status) {
      return navigate("/branch/enroll/student_enroll-list");
    }
    setIsSubmitting(false);
  };
  useEffect(() => {
    const fetchEditMember = async () => {
      const res = await member_edit(id);
      return res?.data;
    };
    const fetchDropdownData = async () => {
      const courseTypeList = await course_type_all();
      const gradeList = await grade_all();
      const days = await get_days();
      return {
        courseTypes: courseTypeList?.data,
        grades: gradeList?.data,
        days: days?.data,
      };
    };

    const fetchData = async () => {
      const memberData = await fetchEditMember();
      const dropdownData = await fetchDropdownData();
      if (memberData) {
        setShowResults(true);
        const data = await get_terms_by_state_user_id(
          memberData?.state,
          id?.id
        );
        setTermData(data?.data);
        const selectedTerm = data?.data.find(
          (term) => term.id == memberData?.term_id
        );
        if (selectedTerm) {
          setDisabledStudentType(selectedTerm?.payment_status);
        }
        // setValue("class_id", memberData.class_id);
        setDisabledUpdateCourse(memberData?.iscourse == 0 ? true : false)
        setUserData({ ...userData, user_id: memberData?.id });
        setValue("first_name", memberData?.first_name);
        setValue("last_name", memberData?.last_name);
        setValue("user_name", memberData?.user_name);
        setValue("gender", memberData?.gender);
        setValue("state", memberData?.gender);
        const dateComponents = memberData?.date_of_birth?.split("-");
        const year = parseInt(dateComponents[0]);
        const month = parseInt(dateComponents[1]) - 1;
        const day = parseInt(dateComponents[2]);
        const formattedDate = year
          ? new Date(Date.UTC(year, month, day)).toISOString().substring(0, 10)
          : "";
        setValue("date_of_birth", formattedDate);
        setValue("school", memberData.school);
        setValue("address", memberData.address);
        setValue("studentID", `CSPRO00${memberData.id}`);
        setValue("classroom_gmail", memberData.classroom_gmail);
        setValue("cs_education", memberData.cs_education);
        setTimeout(() => {
          setValue("term_id", memberData?.term_id);
          setPreviousData({
            termID: memberData?.term_id,
            studentType: memberData?.student_type,
          });
          setValue("day", memberData?.day);
          setValue("grade", memberData?.grade);
          setValue("subject_id", memberData?.subject_id);
        }, 800);
        setShow(memberData.cs_education === "1");
        setGradeId(memberData?.grade);
        setStateId(memberData?.state);
        const fieldsToSet = [
          "branch",
          "type",
          "sibling_grade",
          "course",
          "student_number",
          "p_first_name",
          "p_last_name",
          "p_mobile_phone",
          "mother_mobilenumber",
          "father_mobilenumber",
          "address",
          "city",
          "p_email",
          "pc_email",
          "sibling",
          "email",
          //"password",
          //"confirmPassword",
          "course",
          "class_id",
          "student_type",
        ];
        fieldsToSet.forEach((field) => {
          setValue(field, memberData[field]);
        });
        if (dropdownData.grades) {
          setValue("grade", memberData.grade);
          setValue("course", memberData.course);
        }
      }
      //setBranchList(dropdownData.branches);
      setCoursetypeList(dropdownData.courseTypes);
      setGradeList(dropdownData.grades);
      setDays(dropdownData.days);
    };
    fetchData();
  }, [id]);

  useEffect(() => {
    const fetchStateBranch = async () => {
      if (stateID) {
        const resp = await state_branch_all(stateID);
        const dataa = resp?.data;
        setBranchList(dataa);
      } else {
        const branchList = await branch_all();
        setBranchList(branchList?.data);
      }
    };

    fetchStateBranch();
  }, [stateID]);

  // function for handle stripe modal
  const handleStripeModal = (e) => {
    if (
      (previousData?.termID == term_id &&
        previousData?.studentType !== e) ||
      previousData?.termID !== term_id
    ) {
      setIsOpenPaymentModal(e == 1 ? true : false);
      setUserData({ ...userData, term_id: term_id });
    }
  };
  const handleStudentTypeOnclose = (value) => {
    setValue("student_type", value);
  };
  useEffect(() => {
    const selectedTerm = termData.find(
      (term) => term.id == term_id
    );
    if (selectedTerm) {
      setDisabledStudentType(selectedTerm?.payment_status);
    }
  }, [term_id])

  return (
    <>
      {showResults ? (
        <div className="right-nav" id="dash-event">
          <div className="modal-content">
            <div className="modal-header">
              <Link
                className="edit-btn"
                to={`/branch/enroll/student_enroll-list`}
                onClick={(e) => {
                  handleNavigation(e, isDirty);
                }}
              >
                <i class="fa fa-arrow-left" aria-hidden="true"></i>
              </Link>
            </div>
            <div className="modal-body">
              <Form
                className="form-horizontal"
                onSubmit={handleSubmit(onSubmit)}
              >
                {/* Student information */}
                <div className="col-md-12">
                  <div className="form-group">
                    <label><b>Student information</b></label>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>First name *</label>
                      <input type="text" className="form-control" placeholder="First name" {...register("first_name", { required: "This is required", validate: (value) => /^[A-Za-z\s]+$/.test(value) || "Only letters are allowed" })} />
                      {errors.first_name && <span className="validation-error">{errors.first_name.message}</span>}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Last name *</label>
                      <input type="text" className="form-control" placeholder="Last name" {...register("last_name", { required: "This is required", validate: (value) => /^[A-Za-z\s]+$/.test(value) || "Only letters are allowed" })} />
                      {errors.last_name && <span className="validation-error">{errors.last_name.message}</span>}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Gender *</label>
                      <select className="form-select form-control" {...register("gender", { required: true })}>
                        <option value="">Select</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                      </select>
                      {errors.gender && errors.gender.type === "required" && <span className="validation-error">This is required</span>}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>School</label>
                      <input type="text" className="form-control" placeholder="School name" {...register("school")} />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Grade *</label>
                      <select className="form-select form-control" {...register("grade", { validate: (value) => value !== "" || "This is required" })} onChange={(e) => {setGradeId(e.target.value);setValue('term_id', '')}}>
                        <option value="">Select</option>
                        {gradelist?.length > 0 ? gradelist.map((elem) => (
                          <option key={elem?.id} value={elem?.id}>{elem.name === 0 ? `Year ${elem.name} (kindy)` : `Year ${elem.name}`}</option>
                        )) : <option>No result</option>}
                      </select>
                      {gradeID ? "" : errors.grade && <span className="validation-error">{errors.grade.message}</span>}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>State</label>
                      <input type="text" className="form-control" value={BranchData?.data?.state_name} disabled />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Branch</label>
                      <select key={branchlist.length} className="form-select form-control" {...register("branch")} disabled>
                        {branchlist?.length > 0 ? [<option value="">Select</option>, ...branchlist?.map((elem) => <option value={elem?.id}>{elem?.branch_name}</option>)] : [<option value="">Branch not available</option>]}
                      </select>
                    </div>
                  </div>
                </div>

                {/* Parent / guardian */}
                <div className="row">
                  <div className="col-md-12">
                    <hr className="mt-3" />
                    <div className="form-group">
                      <label><b>Parent / guardian</b></label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Parent first name</label>
                      <input type="text" className="form-control" placeholder="First name" {...register("p_first_name", { validate: (value) => value === "" || /^[A-Za-z\s]+$/.test(value) || "Only letters are allowed" })} />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Parent last name</label>
                      <input type="text" className="form-control" placeholder="Last name" {...register("p_last_name", { validate: (value) => value === "" || /^[A-Za-z\s]+$/.test(value) || "Only letters are allowed" })} />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Primary contact *</label>
                      <div className="input-group branch-prepend">
                        <div className="input-group-prepend">
                          <div className="input-group-text">+61</div>
                        </div>
                        <input type="text" className="form-control" placeholder="04XX XXX XXX" onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }} {...register("mother_mobilenumber", { required: "Mobile number is required", pattern: { value: /^0[2-8]\d{8}$|^04\d{2}\s\d{3}\s\d{3}$/, message: "Enter a valid Australian phone number" }, validate: { isNumeric: (value) => value === "" || /^\d+$/.test(value.replace(/\s+/g, "")) || "Phone number must contain only numbers" } })} maxLength={10} />
                      </div>
                      {errors.mother_mobilenumber && <span className="validation-error">{errors.mother_mobilenumber.message}</span>}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Alternate contact</label>
                      <div className="input-group branch-prepend">
                        <div className="input-group-prepend">
                          <div className="input-group-text">+61</div>
                        </div>
                        <input type="text" className="form-control" placeholder="04XX XXX XXX" onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }} {...register("father_mobilenumber", { pattern: { value: /^0[2-8]\d{8}$|^04\d{2}\s\d{3}\s\d{3}$/, message: "Enter a valid Australian phone number" }, validate: { isNumeric: (value) => value === "" || /^\d+$/.test(value.replace(/\s+/g, "")) || "Phone number must contain only numbers" } })} maxLength={10} />
                      </div>
                      {errors.father_mobilenumber && <span className="validation-error">{errors.father_mobilenumber.message}</span>}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Parent email *</label>
                      <input type="text" className="form-control" placeholder="email@example.com" {...register("p_email", { required: true, pattern: { value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message: "Please enter a valid email address" } })} />
                      {errors.p_email && errors.p_email.type === "required" && <span className="validation-error">Parent email is required</span>}
                      {errors.p_email && errors.p_email.message && <span className="validation-error">{errors.p_email.message}</span>}
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Sibling</label>
                      <input type="text" className="form-control" placeholder="Sibling name" {...register("sibling", { maxLength: { value: 15, message: "Max 15 characters" } })} />
                      {errors.sibling && <div className="text-danger">{errors.sibling.message}</div>}
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Sibling grade</label>
                      <select className="form-control form-select" {...register("sibling_grade")}>
                        <option value="">Select</option>
                        {gradelist?.length > 0 ? gradelist.map((elem) => (
                          <option key={elem?.id} value={elem?.id}>{elem.name === 0 ? `Year ${elem.name} (kindy)` : `Year ${elem.name}`}</option>
                        )) : <option>No result</option>}
                      </select>
                    </div>
                  </div>
                </div>

                {/* Account */}
                <div className="row">
                  <div className="col-md-12">
                    <hr className="mt-3" />
                    <div className="form-group">
                      <label><b>Account</b></label>
                    </div>
                  </div>
                  <div className="col-md-8">
                    <div className="form-group">
                      <label>Email *</label>
                      <input type="text" className="form-control" autoComplete="off" {...register("email", { required: "Email is required", pattern: { value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i, message: "Please enter a valid email address" } })} readOnly />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>User Name</label>
                      <input type="text" className="form-control" readOnly style={{ background: "#f3f4f6" }} {...register("user_name")} />
                      <small className="text-muted">User name is the sign-in ID and is linked to Test Bank, so it can't be changed.</small>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Password</label>
                      <input type="password" className="form-control" autoComplete="new-password" placeholder="Leave blank to keep current" {...register("password", { validate: (value) => { if (!value) return true; return value.length >= 4 || "Password must be at least 4 characters"; } })} />
                      {errors.password && <p className="validation-error">{errors.password.message}</p>}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Confirm password</label>
                      <input type="password" className="form-control" placeholder="Leave blank to keep current" {...register("confirmPassword", { validate: (value) => { if (!watch("password")) return true; return value === watch("password") || "Passwords do not match"; } })} />
                      {errors.confirmPassword && <p className="validation-error">{errors.confirmPassword.message}</p>}
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Button
                    type="submit"
                    className="btn btn-primary"
                    disabled={isSubmitting}
                  >
                    Save
                  </Button>
                </div>
              </Form>
            </div>
          </div>
          <StripePaymentModal
            isOpen={isOpenPaymentModal}
            onClose={setIsOpenPaymentModal}
            totalAmount={amount}
            handleStudentTypeOnclose={handleStudentTypeOnclose}
            setPaymentIntentID={setPaymentIntentID}
            userData={userData}
            term_id={term_id}
            type={type}
            user_id={id?.id}
            grade_id={grade_id}
          />
          {/* <UpdateStudentCourse isOpen={openUpdateCourseModal} onClose={setOpenUpdateCourseModal} user_id={id?.id} /> */}
        </div>
      ) : (
        <DataLoader />
      )}
    </>
  );
};
export default EditMember;
